import { createApp } from 'vue';
import Index from '../components/Contact/Schedule.vue';

const index = createApp(Index);
index.mount('#contactSchedule');
